var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.query)?_c('div',[_c('div',{staticClass:"mb-5"},[_vm._v("Query")]),_c('params-table',{attrs:{"params":_vm.query}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }